import state from './moduleBasicValuesState.js'
import mutations from './moduleBasicValuesMutations.js'
import actions from './moduleBasicValuesActions.js'
import getters from './moduleBasicValuesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
